import React, { ReactElement } from 'react';

/**
 * Support page component shows the support page of the application.
 * @returns - Support page.
 */
export default function Support(): ReactElement {
  return <div>support.page</div>;
}
